function AddOrRemove<T>(set: Set<T>, value: T): Set<T> {
  const newSet = new Set(set)

  if (newSet.has(value)) {
    newSet.delete(value)
  } else {
    newSet.add(value)
  }

  return newSet
}

export default { AddOrRemove }
